module.exports = __webpack_public_path__ + "static/project2-4662caa7715d5c3e64b2edf6bbed3515.svg";